import { render } from "./AdPlacementSettings.vue?vue&type=template&id=11f1af32"
import script from "./AdPlacementSettings.vue?vue&type=script&lang=js"
export * from "./AdPlacementSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__